import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './Authentication.css';
import Btn from '../Ui/Btn';


const LogoutButton = ({ closeDropdown }) => {
	const { logout } = useAuth0();

	const handleLogout = () => {
		if (closeDropdown) closeDropdown(); // Ferme le dropdown avant de se déconnecter
		logout({ returnTo: window.location.origin });
	};

	return (
		<Btn
			messageToolTip={'Log Out'}
			message={'Log Out'}
			icon="fas fa-sign-out-alt"
			style="outline"
			onClickFunction={handleLogout}
		/>
	);
};

export default LogoutButton;